import { AuthAttribute, authAttributeSerializer } from "@megaron/access-control";
import { HttpUri } from "@megaron/http-uri";
import { MegaraxUri } from "@megaron/megarax-uri";
import { Ok } from "@megaron/result";
import { Serializer, Serializers } from "@megaron/serializers";

import { ResourceId, resourceIdSerializer } from "./ResourceId";
import { signalSerializer, Signal } from "./signal";

export type BaseDoc<T extends string = string> = {
  docType: T;
  docId: ResourceId<T>;
  uri?: string;
  authorizedAttributes: AuthAttribute[];
  name: string;
  isArchived: boolean;
  boostedFor: AuthAttribute[];
  signals: Signal[];
};

export const baseDocDefaults = {
  signals: [] as Signal[],
};

const signalsSerializer: Serializer<Signal[]> = {
  serialize: (signals) => signalSerializer.array().serialize(signals),
  deserialize: (raw) => (raw === undefined ? Ok<Signal[]>([]) : signalSerializer.array().deserialize(raw)),
};

export const baseDocSerializer = <T extends string>(docType: T) =>
  Serializers.object({
    docType: Serializers.stringOneOf(docType),
    docId: resourceIdSerializer(docType),
    uri: Serializers.first(MegaraxUri.serializer, HttpUri.serializer, Serializers.string).optional(),
    authorizedAttributes: authAttributeSerializer.array(),
    boostedFor: authAttributeSerializer.array(),
    isArchived: Serializers.boolean,
    name: Serializers.string,
    signals: signalsSerializer,
  });
